var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcarus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1333.333 1333.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-787.08 500h1000V-500h-1000Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-120.718-134.132h373.31v373.31h-373.31z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-115.877-3.434h373.31v373.31h-373.31z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-180.545-144.446h373.31v373.31h-373.31z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-268.524-29.287h373.31v373.31h-373.31z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-133.193-70.65h373.31v373.31h-373.31z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-208.333-89.26h373.31v373.31h-373.31z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-214.7-232.827h373.31v373.31H-214.7z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-175.434-301.237h373.31v373.31h-373.31z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-213.636-298.824h373.31v373.31h-373.31z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-206.542-267.184h373.31v373.31h-373.31z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-198.994-304.017h373.31v373.31h-373.31z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-230.12-292.253h373.31v373.31h-373.31z"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-158.55-128.53-287.079-287.079-287.079-158.55 0-287.08 128.529-287.08 287.079s128.53 287.079 287.08 287.079S0 158.55 0 0",
    clipPath: "url(#a)",
    style: {
      fill: "#e0a800",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#002566",
      strokeWidth: 10,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 1049.44 666.667)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(-29.7 1029.706 -753.961)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "58.2367px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "I")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(-22.575 1265.29 -1116.666)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "58.2368px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "C")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(-12.254 2054.533 -2489.934)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "58.2367px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "A")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(-2.023 10724.813 -17592.205)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "58.2367px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "R")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(8.124 -2233.384 4982.737)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "58.2362px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "U")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(18.031 -808.553 2502.88)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "58.2367px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "S")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(24.788 -494.99 1975.324)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "58.2367px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(28.74 -376.358 1762.914)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "58.2367px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "I")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(70.69 -375.986 606.563)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "53.0002px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "C")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(64.447 -474.1 675.412)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: 53,
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "I")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(58.916 -562.374 725.337)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "52.9998px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "T")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(51.014 -728.02 828.3)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: 53,
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "Y")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(45.406 -885.706 939.594)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: 53,
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(39.693 -1072.735 1043.044)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "52.9999px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "A")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(31.1 -1495.333 1310.725)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "52.9999px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "P")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(22.795 -2195.31 1749.993)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "53.0002px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "E")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(14.45 -3694.107 2689.843)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "52.9999px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "X")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(8.552 -6510.364 4544.028)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "52.9999px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(3.066 -18788.246 12199.97)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "53.0001px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "F")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(-4.397 13683.902 -8252.864)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "53.0002px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "L")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(-9.903 6248.975 -3638.756)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: 53,
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "I")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(-16.494 3880.214 -2050.918)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "53.0001px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "G")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(-25.869 2576.046 -1240.73)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "52.9997px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "H")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(-34.15 2011.43 -894.959)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "52.9999px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "T")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(-39.64 1759.152 -756.39)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "53.0001px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(-45.117 1576.795 -621.847)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: 53,
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "T")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(-53 1372.039 -490.602)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: 53,
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "E")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(-61.607 1204.872 -383.396)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "53.0002px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "A")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(-71.315 1061.864 -289.518)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "52.9997px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "M")), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c6.161.591 12.589 3.006 17.433 6.883 2.599 2.079 10.943 10.509 9.257 13.893-.302.606-6.485 4.328-7.329 4.534-1.62.393-4.056-3.627-5.181-4.785-2.236-2.298-6.004-5.121-7.772-7.34C5.573 12.138-.59.437 0 0m132.227 0c-1.81 4.811-4.491 10.617-8.006 14.421-.843.912-2.043 1.397-2.871 2.323-2.638 2.954-5.725 6.248-7.551 9.696l-8.274-5.674c-1.091-1.736 4.738-9.342 6.154-10.86C116.807 4.409 124.601-.021 132.227 0m-6.28 36.309-7.888-6.812c8.495-10.796 20.769-23.705 35.9-20.774.803.588.132.687-.194 1.237-6.695 11.288-16.427 18.476-26.752 26.169-.332.254-.668.284-1.066.18M-23.139 8.501c10.114-2.341 19.58 3.304 26.924 9.669 3.689 3.198 7.583 7.247 10.834 10.818l-8.018 7.166-.909-.013C-5.056 27.94-16.2 20.501-23.139 8.501m18.353 41.487-1.335-.182c-7.317-5.573-16.587-8.864-24.255-13.532-3.065-1.865-7.179-5.147-9.988-7.485-.834-.694-5.155-4.111-4.973-4.936 9.636-6.246 21.084-1.835 29.902 3.62 6.252 3.868 11.811 9.052 17.796 13.143zm181.875-25.902c.466.592-1.238 1.932-1.665 2.342-7.786 7.479-17.357 12.061-26.514 17.404-3.551 2.073-6.894 4.479-10.385 6.648l-7.7-9.192c-.079-.35 3.322-3.391 4.014-3.972 10.992-9.221 27.686-21.764 42.25-13.23m-29.743 43.439L141.4 54.766c18.469-10.102 42.192-25.936 60.709-6.838zm-161.992 0c-17.801-8.136-36.907-12.866-55.242-19.594 11.492-13.556 27.805-9.773 42.195-3.478 6.718 2.939 12.859 7.326 19.665 9.855zm243.21 17.469c-24.981-1.758-50.278-3.165-75.247-.449l-3.585-12.001c.604-1.962 21.294-6.682 24.437-7.231 10.908-1.904 21.564-2.877 32.177 1.055 9.045 3.35 17.046 10.607 22.218 18.626m-248.873.004c-4.13-.763-8.814-1.627-12.989-1.884-7.844-.482-15.808-.104-23.588.015-7.415.113-14.803.083-22.21.458l-18.186 1.879c6.67-8.888 14.806-17.007 25.764-20.275 13.582-4.051 30.32-.97 43.653 3.046 1.481.446 11.314 3.618 11.327 4.246-2.101 3.611-3.165 8.431-3.771 12.515m-2.409 16.953c-30.008 4.833-58.732 14.891-86.839 26.019-.669-.728 6.189-12.66 7.255-14.227C-85.3 88.75-56.746 87.954-29.023 89.229c2.336.108 4.816.888 7.301.494zm177.139-11.757c26.023-1.786 56.468-3.935 75.331 17.465 5.336 6.055 9.755 13.683 12.503 21.258-27.63-12.361-56.933-21.588-86.888-26.45 1.018-1.598-1.379-11.829-.946-12.273m1.427 17.942c16.685 3.334 34.263 6.572 49.422 14.56 19.597 10.328 36.186 30.118 40.762 52.028-15.568-11.302-31.699-21.934-48.203-31.837-12.874-7.724-25.998-14.917-39.595-21.323-3.2-.848-3.479-12.649-2.386-13.428m-178.518.002c-.201 4.168 2.014 9.936-1.915 12.959-31.58 14.501-61.234 33.166-89.22 53.627 3.225-17.07 15.174-34.064 28.84-44.588 17.779-13.692 40.534-18.651 62.295-21.998m133.169 23.614c-3.333-.705-9.463-4.12-12.295-1.206-3.596 3.7 3.532 3.538 5.788 4.175 14.223 4.014 20.761 23.734 5.576 31.747-4.538 2.394-5.836.524-8.528 1.372-.932.294-5.125 3.806-6.633 4.718-26.833 16.229-61.545 1.359-73.046-26.515-5.687-13.783-.912-21.221 2.116-34.025 1.815-7.67 1.016-12.343-2.222-19.463l7.079 1.418c-1.064-9.074-5.01-18.619 4.718-24.558-1.22 3.843-1.193 7.341-.135 11.237.529 1.945 2.618 7.368 5.356 5.548 1.054-1.183-.422-2.683-.74-4.024-1.733-7.302-.187-16.694 8.274-18.423-7.526 14.138 7.892 23.746 3.316 38.02-2.997 9.346-6.243 14.748-5.201 25.487.332 3.423 5.048 16.114 8.032 17.494 1.627.753 2.459-.82 2.342-2.318-.18-2.32-3.173-8.242-4-11.16-4.722-16.659 6.102-24.087 4.487-38.961-.986-9.077-9.665-14.185-5.775-25.603.781-2.291 2.306-2.996 3.418-4.849.61-.14.565.491.695.938 2.957 10.107 1.317 8.809 8.271 17.238.855 1.037.92 3.565 3.308 2.375 1.268-.632 2.607-5.239 2.779-6.675.592-4.948-1.207-9.392 5.954-3.963 9.693 7.349 8.023 17.996 8.377 28.453.063 1.89 1.404 4.056 1.07 6.018-5.278-5.038-3.779-12.92-5.248-19.422-.585-2.59-3.404-10.973-6.969-10.227-2.556.535 1.276 4.831 1.933 6.4 3.315 7.919-.018 17.089 6.073 25.099 1.188 1.563 3.014 2.793 4.215 4.286 3.631 4.516 8.867 14.522 15.947 11.716 6.375-2.527 3.381-15.89 5.777-16.43 1.972-.445 2.383 7.382 2.805 8.991 1.256 4.79 4.22 9.908 3.086 15.092M27.865 1.887c7.821.697 15.916 15.052 14.534 21.847-1.291 6.344-13.882 13.043-18.794 17.575C9.48 54.344-1.779 75.788-2.829 95.156c-.684 12.623 5.904 26.736-.087 38.165-7.205 13.746-47.767 36.28-62.122 46.494-16.605 11.814-30.372 25.292-43.101 41.189 2.218-28.597 19.462-53.951 42.349-70.276 9.536-6.803 20.485-12.78 30.834-18.279 5.981-3.178 17.234-6.231 17.973-14.139.461-4.932-.765-10.062-.486-15.126 1.471-26.703 13.523-51.094 33.9-68.217 4.31-3.622 10.373-6.642 14.269-10.174 3.788-3.434 2.949-5.658 1.652-10.162-.54-1.877-5.278-11.931-4.487-12.744M220.81 172.562c8.82 11.477 19.901 33.07 19.086 47.743-.029.531.313 1.295-.464 1.168-9.914-14.256-22.796-27.269-36.684-37.698-16.899-12.69-59.001-35.306-66.674-53.746-3.839-9.225-.024-20.56.399-30.16 1.011-22.98-11.697-45.117-28.797-59.503-9.483-7.977-21.943-11.938-14.577-27.317 2.284-4.768 6.21-9.142 11.27-10.924-.404 5.156-4.183 12.398-4.467 17.163-.202 3.387 2.875 5.676 5.185 7.613 3.673 3.08 7.89 5.623 11.564 8.74 20.648 17.52 32.088 41.361 33.516 68.488.641 12.158-3.16 17.168 8.834 24.224 23.791 13.995 44.048 21.097 61.809 44.209M-53.6 33.052c-7.751.821-16.571 6.08-21.497 12.031-2.437 2.944-2.905 4.63.706 6.872l14.414 5.649c-16.123-.136-33.309 10.211-41.281 24.127-7.373 12.869 5.602 8.934 13.165 8.443.626-.041 2.949-.349 3.086.485-13.678 6.546-25.725 21.599-30.355 35.997-1.167 3.631-2.813 7.958 2.253 9.119l22.916-8.511c-13.27 10.123-25.346 27.188-29.053 43.677-.841 3.745-3.173 15.805 4.669 11.752 5.121-2.647 11.32-9.585 16.667-12.611l7.712-4.798c-10.919 12.63-19.297 27.758-22.519 44.299-1.009 5.179-2.841 16.196-1.439 20.976.622 2.123 1.802 3.621 4.249 3.114 2.455-.508 8.921-11.32 11.021-14.037 10.674-13.812 24.181-25.214 38.291-35.379 16.218-11.685 56.04-33.292 63.988-50.295 5.083-10.874-.096-22.344-.579-33.596-.828-19.283 8.253-37.842 21.571-51.224 5.364 3.08 6.451 9.625 7.288 15.226-8.464 4.289-13.038 13.889-9.483 22.991-2.442-.929-7.829-1.109-8.423 2.241-.41 2.313 3.997 6.392 4.886 9.566 2.777 9.923-4.896 21.902-5.453 32.798-1.102 21.517 19.893 44.362 39.589 50.654 18.262 5.834 33.939 2.051 49.102-8.686 1.978-1.401 2.352-.592 4.941-1.23 17.572-4.33 22.326-23.695 9.862-36.53 1.585-2.42 1.401-5.128 1.965-7.836.781-3.746 1.936-5.45 1.177-9.932-.391-2.309-2.889-5.562-3.039-7.729-.197-2.816 2.343-7.289 2.221-10.774-.209-5.952-4.068-15.246-5.543-21.415-1.1-4.6-1.338-11.162-3.358-15.06-2.822-5.446-9.454-7.129-15.195-6.765.443-2.918 3.246-13.319 6.849-13.2 1.928.064 13.292 12.42 15.059 14.669 7.415 9.431 13.203 22.561 14 34.641.827 12.551-4.348 25.941-.635 37.942 6.042 19.527 45.873 41.476 62.627 53.544 13.44 9.68 26.878 21.094 37.146 34.163 2.112 2.689 9.079 14.187 10.994 14.974 7.476 3.071 5.473-12.356 5.073-16.402-1.878-18.987-11.199-36.743-23.137-51.236l25.005 17.739c7.279 1.262 4.192-9.395 3.099-13.499-4.374-16.417-15.064-31.361-27.632-42.491l21.184 8.238c8.582.886 1.433-13.342-.227-16.686-5.798-11.683-15.249-22.717-27.093-28.398.325-.838 2.803-.532 3.558-.485 3.585.22 11.443 1.904 14.16-.437 2.868-2.471-1.879-8.676-3.635-11.033-5.917-7.947-15.69-15.745-25.213-18.706-4.133-1.285-9.19-2.454-13.43-1.921.128-.816.941-.824 1.522-1.071 3.415-1.453 11.063-3.036 13.566-5.324 4.447-4.067-5.306-11.051-8.521-13.155-6.843-4.477-15.456-6.313-23.568-5.007 2.679-3.623 8.981-5.381 7.284-10.845-.532-1.712-4.235-3.004-3.977-4.021 10.256-7.413 15.591-19.736 17.598-31.976 1.661-10.133.428-15.946-.122-25.647-.712-12.57 3.092-20.062 5.045-31.784 1.671-10.027 2.29-23.275 1.101-33.391-.274-2.323-2.578-4.311-4.298-1.912-1.053 1.471-.212 18.235-.44 21.751-.883 13.625-7.433 28.233-7.098 41.582.091 3.667 1.271 7.964 1.458 11.764.866 17.58-3.968 36.714-18.802 47.39-6.304-.765-12.504-.619-18.527 1.505 2.008-3.611 9.355-10.221 3.42-13.569-6.042-3.408-16.752-.938-22.782 1.763 10.728-20.42-20.316-8.645-26.441-1.413 2.232-10.202-1.238-10.911-9.293-6.218C91.552 3.303 84.513 13.53 85.48 23.367c.677 6.892 6.858 12.236 12.271 15.833v.695c-5.73 3.772-7.714 12.362-8.031 18.861-.152 3.108-.442 10.318.214 13.048.162.677.322 1.493 1.037 1.798 6.093 2.105 2.056-10.38 3.945-11.984 3.413-1.374 8.003.773 10.167 3.537 2.793 3.564 2.239 8.171 3.201 12.383 1.516 6.641 6.124 18.439 5.524 24.695-.313 3.261-2.19 6.512-1.919 9.925.337 4.258 4.056 6.599 2.388 11.089l-3.162-7.453c-1.266-2.801-.639-6.355-1.791-9.073-1.205-2.844-3.533-4.416-6.593-3.293-2.752 1.011-3.936 5.626-4.039 8.273-.111 2.865 1.616 5.782-1.381 8.034-3.825 2.875-7.051-4.325-7.832-7.336-1.465-5.646-1.255-14.666 1.329-19.956 2.872-5.877 5.109-.493 6.633-.45l1.299-.714c.622-7.273-7.419-7.893-11.371-2.975.338-8.946-8.485-22.944-17.449-24.818-7.199-1.506-6.457 3.653-8.291 8.76-3.397-2.792-2.129-13.302-5.25-15.054-3.52-1.977-5.395 1.182-8.081 1.726-1.898.385-3.832-.173-5.81.33-1.863.475-4.051 2.482-5.649 3.555-.647-5.441-2.425-11.209-6.148-15.344-.627-.697-2.495-1.331-2.322-2.301 5.673-6.176 15.572-9.809 18.874-17.99C50.914 18.07 42.618 4.144 34.816-.583c-7.812-4.734-13.58-3.772-11.204 6.713l-.936.001C19.243.136 10.286-4.42 3.484-5.141-7.371-6.293-8.142-2.093-3.306 6.602c-6.65-2.541-13.107-4.876-20.322-3.08-1.281.319-4.076 1.229-4.737 2.345-2.632 4.442 5.51 11.283 4.748 12.073-3.915-2.055-9.459-2.75-13.869-2.304-5.173.524-5.076 2.789-10.166-.807-11.361-8.024-16.996-27.932-17.713-41.214-.318-5.897.731-12.813.138-18.661-.723-7.143-4.297-15.707-5.85-22.957-2.326-10.862-2.758-21.586-2.848-32.661-.226-1.353-2.047-1.468-3.204-1.285-1.313.419-1.663 5.352-1.755 6.768-1.269 19.543 5.697 32.085 7.999 49.654 1.337 10.197-.298 20.792 1.684 31.845 2.385 13.304 8.554 26.172 20.079 33.747-6.789 5.301 1.31 9.943 5.672 12.993-.002 1.16-1.387-.006-1.649-.006-2.656 0-5.957-.269-8.501 0",
    clipPath: "url(#b)",
    style: {
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 578.75 736.698)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.304-.261-1.954-.623-2.392-.521L-3.557.695c-2.605 13.101-6.622 25.995-12.619 37.908l-6.466-23.752-.963-.936c-4.305-1.219-3.778 2.078-3.249 5.112 1.637 9.407 5.995 19.019 6.986 28.726-2.441 8.753-4.64 17.613-7.747 26.163-3.176 8.735-8.221 17.683-8.646 27.242-.081 1.81-.076 6.285 2.86 4.756 1.206-.628 3.312-11.258 4.024-13.454 2.088-6.437 5.526-12.713 7.781-19.136 2.094-5.967 3.438-12.175 5.44-18.172 3.844-11.51 9.271-22.734 12.988-34.236C-2.079 17.547 2.549 2.192 0 0",
    clipPath: "url(#c)",
    style: {
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 572.296 910.96)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c1.734.515 2.107-.486 2.051-2.028C1.9-6.255-.436-13.19-1.132-17.776c-5.899-38.877 12.177-73.468 8.359-113.195-.171-1.779-.486-8.756-2.593-8.755-3.069.004-.813 7.314-.713 9.227 2.12 40.793-18.042 77.501-8.748 118.308C-4.332-10.018-1.911-.568 0 0",
    clipPath: "url(#d)",
    style: {
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 658.52 722.946)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-6.102-26.119c-4.147-2.244-4.465 1.179-4.279 4.629.543 10.056 6.928 23.544 7.096 33.088.081 4.611-1.669 11.079-1.924 16.011-.614 11.893.519 26.528 5.605 37.409 1.021 2.187 5.218 8.719 4.756 2.35-.397-5.483-3.096-12.035-4.064-17.682-3.696-21.55 1.583-40.56 6.519-61.261l-.279-1.177C1.284-16.467 1.392-3.588 0 0",
    clipPath: "url(#e)",
    style: {
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 775.825 876.491)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-2.885-2.639-7.916-6.388-11.939-4.936-.81 3.303 2.275 3.326 4.338 4.744C-3.331 2.743.745 7.94 3.497 12.323c.943 1.5 2.266 6.559 4.515 5.781 2.381-.825-.401-6.805-1.043-8.308C5.2 5.658 3.309 3.027 0 0",
    clipPath: "url(#f)",
    style: {
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 595.385 821.34)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c1.602.483 3.532-3.772 4.482-4.945 2.53-3.125 5.72-7.089 8.714-9.703 1.314-1.146 7.335-4.782 7.576-5.172 1.354-2.187-.288-3.066-2.517-2.521C12.05-20.826 4.089-12.339 1.252-6.759.684-5.641-1.92-.579 0 0",
    clipPath: "url(#g)",
    style: {
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 695.57 796.527)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.46 3.468-1.419 13.114 1.38 15.375 3.78 3.054 1.616-4.131 1.454-5.703C2.687 8.248 2.805-1.851 0 0",
    clipPath: "url(#h)",
    style: {
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 704.06 605.104)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c1.576-2.487-3.704-4.629-5.136-5.834-7.822-6.58-13.618-17.823-15.042-27.932-1.82-12.909 4.278-23.265 3.258-36.315-.165-2.12-.975-8.768-3.972-8.138-2.543.535-.012 5.867.128 7.734.641 8.498-4 18.338-4.667 26.872-1.008 12.901 5.039 31.227 15.1 39.668C-8.886-2.733-1.497 2.362 0 0",
    clipPath: "url(#i)",
    style: {
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 651.705 513.891)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c1.481-3.315.111-7.354-1.361-10.453-6.235-13.132-23.675-14.006-30.718-27.84-1.022-2.007-2.527-7.818-3.204-8.602-.574-.665-1.053-.788-1.908-.689-1.535 7.241 2.57 15.826 7.778 20.792 8.135 7.758 21.236 10.717 25.838 21.856C-2.411-2.12-4.577 2.142 0 0",
    clipPath: "url(#j)",
    style: {
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 702.642 517.108)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c1.349.224 4.529.304 3.211-1.793-.277-.443-7.582-3.784-9.184-4.983-9.466-7.083-8.452-14.015-9.495-24.505-.371-3.728-3.5-11.592-8.049-10.905-1.592 2.325.994 4.122 1.795 5.824 4.472 9.506-1.267 18.479 6.02 27.509C-12.491-4.874-4.999-.83 0 0",
    clipPath: "url(#k)",
    style: {
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 693.183 559.294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.305-.306.562-1.136.568-1.571.025-2.062-4.606-5.621-6.105-7.536-2.545-3.251-4.807-10.708-9.414-9.144-.239.775.06 1.474.32 2.185.803 2.202 5.257 10.281 6.73 12.157C-6.55-2.189-2.2 2.2 0 0",
    clipPath: "url(#l)",
    style: {
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 683.119 510.183)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c3.673 1.281 3.756-2 2.698-4.593C1.041-8.655-3.82-12.879-7.437-15.235c-.91-.593-9.827-6.153-7.754-1.692.477 1.026 6.868 5.313 8.506 7.079C-5.168-8.214-.562-.196 0 0",
    clipPath: "url(#m)",
    style: {
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 724.621 525.87)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcarus);
export default __webpack_public_path__ + "static/media/ICARUS.126e34b6d0c742f2b5af581ce74a9849.svg";
export { ForwardRef as ReactComponent };